import { render } from "./SystemLogsDashboard.vue?vue&type=template&id=6ee2226a&scoped=true"
import script from "./SystemLogsDashboard.vue?vue&type=script&lang=js"
export * from "./SystemLogsDashboard.vue?vue&type=script&lang=js"

import "./SystemLogsDashboard.vue?vue&type=style&index=0&id=6ee2226a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee2226a"]])

export default __exports__